export const CONFIGURATION_MIGRATION_GENERAL_KEY = 'general';
export const CONFIGURATION_MIGRATION_PERSONAL_KEY = 'personal';
